import React from "react";
import Modal from "../../../../../components/ui/Modal";
import Button from "../../../../../components/ui/Button";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useNavigate } from "react-router-dom";
import { remittanceActions } from "../../../state/remittanceSlice";
import { remittanceApi } from "../../../api/remittanceApi";
import { toast } from "react-toastify";
import { AppStrings, logApiErrorToSentry } from "../../../utils";
import SelectDropdown from "../../ui/SelectDropdown";
import { DebounceInput } from "react-debounce-input";

interface SendPaymentLinkModalProps {
  visible: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export const SendPaymentLinkModal: React.FC<SendPaymentLinkModalProps> = ({
  visible,
  onSubmit,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const authState = useAppSelector((state) => state.auth);
  const remitterState = useAppSelector((state) => state.remittance);
  const { transactionDetail, payment } = useAppSelector((state) => state.remittance);

  const disabled =
    !payment?.sendPaymentLinkInput?.bankDropdown ||
    !payment?.sendPaymentLinkInput?.accountNumber ||
    !payment?.sendPaymentLinkInput?.IFSCcode;
  const loading =
    payment?.sendPaymentLinkInput?.pennyDropLoading ||
    payment?.sendPaymentLinkInput?.requestRazorLoading;

  return (
    <Modal
      header="Generate Payment Link"
      headerClass="flex items-center justify-between w-full text-[22px] font-semibold"
      modalClass="bg-gray-200"
      visible={visible}
      maskClosable={false}
      closeHandler={onClose}
      closable={true}
    >
      {/* BODY */}
      <div className="flex flex-col mt-5">
        <span className="float-left font-semibold">
          Your bank
          <span className="text-red-100 text-sm pl-1">{"*"}</span>
        </span>
        <SelectDropdown
          data={payment?.netBankingList?.list}
          value={payment?.sendPaymentLinkInput?.bankDropdown}
          onChange={(response) => {
            dispatch(remittanceActions.setSendPaymentLinkInput({ bankDropdown: response }));
          }}
          getLabel={(item) => item?.bankName}
          getValue={(item) => item?.bankId}
          width={"460px"}
          placeHolderFontSize={"16px"}
          textSize={"16px"}
          fontWeight={100}
          backgroundColor="#f3f4f6"
          placeholder={"Select your bank"}
          isSearchable={true}
          isLoading={payment?.netBankingList?.loading}
        />
        <span className="float-left font-semibold mt-5">
          Account number
          <span className="text-red-100 text-sm pl-1">{"*"}</span>
        </span>
        <DebounceInput
          className={"w-full rounded-md p-[3.4%] bg-[#f3f4f6] text-base outline-none"}
          name="accountNumber"
          type="number"
          value={payment?.sendPaymentLinkInput?.accountNumber}
          debounceTimeout={0}
          onChange={(e: any) => {
            let { value } = e.target;
            dispatch(remittanceActions.setSendPaymentLinkInput({ accountNumber: value }));
          }}
          fullWidth
          inputClasses="text-[20px] bg-blue-100"
          disabled={false}
          placeholder={"Enter your account number"}
        />

        <span className="float-left font-semibold mt-5">
          IFSC code
          <span className="text-red-100 text-sm pl-1">{"*"}</span>
        </span>
        <DebounceInput
          className={"w-full rounded-md p-[3.4%] bg-[#f3f4f6] text-base outline-none"}
          name="ifsccode"
          type="text"
          value={payment?.sendPaymentLinkInput?.IFSCcode}
          debounceTimeout={0}
          onChange={(e: any) => {
            let { value } = e.target;
            dispatch(remittanceActions.setSendPaymentLinkInput({ IFSCcode: value }));
          }}
          fullWidth
          inputClasses="text-[20px] bg-blue-100"
          disabled={false}
          placeholder={"Enter your IFSC code"}
        />

        <div className="flex items-center justify-center align-middle  mt-8">
          <Button
            bgColor={disabled ? "bg-gray-300" : "bg-[#006EFF]"}
            fontStyle={{
              fontFamily: "font-Inter",
              fontSize: "text-sm",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{ borderRadius: "rounded-lg" }}
            className={"p-4 hover:bg-blue-600 w-[10rem]"}
            onClickHandler={onSubmit}
            disabled={disabled || loading}
            isLoading={loading}
          >
            <div className="flex items-center gap-1">{"Submit"}</div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
